import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractTimeInput} from "../abstract-time-input";
import {FUIEventsService} from "../../../../events/events.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIEditTimeInputComponent),
            multi: true
        }
    ],
    selector: "fui-edit-time-input",
    styleUrls: ["./edit-time-input.component.scss"],
    templateUrl: "./edit-time-input.component.html",
    standalone: false
})
export class FUIEditTimeInputComponent extends FUIAbstractTimeInput {
    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef,
                eventsService: FUIEventsService) {
        super(elementRef, changeDetectorRef, eventsService);
    }
}
